import React from "react";
import { IBodyContentProps } from "./BodyContentComponent.types";
import { Typography } from "antd";
import { Col, Row } from "antd";
import "./BodyContent.scss";

const { Title } = Typography;

const BodyContentComponent = ({
  icon,
  bodyHeaderText,
  bodyText,
}: IBodyContentProps) => {
  return (
    <Row className={"BodyContent"}>
      <Col span={24}>
          <Row gutter={[8,0]}>
            <Col span={3} className="BodyContent_icon">
              {icon}
            </Col>
            <Col span={20}>
              <Title className={"BodyContent-text-header"}>
                {bodyHeaderText}
              </Title>
            </Col>
          </Row>
          {bodyText ? (
            <Row style={{maxWidth:'380px'}}>
              <div>
                <Title className={"BodyContent-text-description"} level={4}>
                  {bodyText}
                </Title>
              </div>
            </Row>
          ) : ("")}
      </Col>
    </Row>
  );
};

export default BodyContentComponent;
